import React from 'react';
import { useAttachsState } from 'providers/attachs-state';
import { HideDomElements } from 'components/misc/globalStyles';
import { useEmlData } from 'providers/eml-data';
import { useGlobalProps } from 'providers/global-props';
import ImgViewer from 'components/ImageGallery';
import ImgViewerStyles from './styles';
import toolbarButtons from './toolbarButtons';
import useMessageStore from 'state/messageState';

const wrapperClassName = 'inx-img-viewer';
const getImageIndex = (id, galleryArray) => galleryArray.findIndex((item) => item === id);

// Default state lazy initialization
const init = (imgIndex) => ({
    index: imgIndex,
    rotationAngle: 0,
    transformStyle: ''
});

const reducer = (state, action) => {
    const { payload, type } = action;
    switch (type) {
    case 'reset':
        return init(payload);
    case 'setImgIdx':
        return {
            ...state,
            index: payload
        };
    case 'setRotationAngle':
        return {
            ...state,
            rotationAngle: payload
        };
    case 'setTransformStyle':
        return {
            ...state,
            transformStyle: payload
        };
    default:
        // throw new Error('Unexpected action: ', action);
        return state;
    }
};

const ImgGalleryPanel = () => {
    const {
        historyBack,
        isPreviewMode,
        setStateValue,
        clickedItemData: itemData,
    } = useAttachsState();
    const { MAPI } = useGlobalProps();
    const emlData = useMessageStore((state) => state.emlData);
    const {attachments} = emlData;
    const imgIdsList = attachments ? attachments.map(item => item.hashId) : [];
    const currentImgIndex = getImageIndex(itemData.hashId, imgIdsList);
    const [ currentImg, dispatch ] = React.useReducer(reducer, currentImgIndex, init);
    const imgListLength = imgIdsList.length;
    const getDataById = (id) => attachments.find((item) => item.hashId === imgIdsList[id]);

    function getImgSrc(id, thumb = false) {
        const srcType = thumb ? 'thumb' : 'href';
        return MAPI.baseUrl + getDataById(id)[srcType];
    }

    function nextImgSrc(thumb = false) {
        const
            index = (currentImg.index + 1) % imgListLength,
            imgSrc = getImgSrc(index, thumb);
        return imgListLength > 1 ? imgSrc : undefined;
    }

    function nextImgIndex() {
        const index = (currentImg.index + 1) % imgListLength;
        setStateValue('clickedItemData', getDataById(index));
        dispatch({ type: 'reset', payload: index });
    }

    function prevImgSrc(thumb = false) {
        const
            index = (currentImg.index + imgListLength - 1) % imgListLength,
            imgSrc = getImgSrc(index, thumb);
        return imgListLength > 1 ? imgSrc : undefined;
    }

    function prevImgIndex() {
        const index = (currentImg.index + imgListLength - 1) % imgListLength;
        setStateValue('clickedItemData', getDataById(index));
        dispatch({ type: 'reset', payload: index });
    }

    function rotateImg(direction) {
        // console.log(direction);
        const
            image = document.querySelector('.ril-image-current'),
            transformStyle = currentImg.transformStyle || image.style.getPropertyValue('transform'),
            angle = direction == 'right'
                ? currentImg.rotationAngle + 90
                : currentImg.rotationAngle - 90;

        if (currentImg.transformStyle == '') {
            dispatch({
                type: 'setTransformStyle',
                payload: transformStyle
            });
        }
        dispatch({ type: 'setRotationAngle', payload: angle });
        image.style.setProperty('transform', `${transformStyle} rotate(${angle}deg)`);
    }

    return <>
        <HideDomElements />
        <ImgViewerStyles
            previewMode={isPreviewMode()}
            wrapperClassName={wrapperClassName}
        />
        <ImgViewer
            clickOutsideToClose={false}
            enableZoom={false}
            imageCaption={getDataById(currentImg.index).name}
            mainSrc={getImgSrc(currentImg.index)}
            // mainSrcThumbnail={getImgSrc(currentImageIdx, true)}
            nextSrc={nextImgSrc()}
            // nextSrcThumbnail={nextImgSrc(true)}
            prevSrc={prevImgSrc()}
            // prevSrcThumbnail={prevImgSrc(true)}
            onCloseRequest={historyBack}
            onMovePrevRequest={prevImgIndex}
            onMoveNextRequest={nextImgIndex}
            toolbarButtons={toolbarButtons(rotateImg)}
            wrapperClassName={wrapperClassName}
        />
    </>;
};

export default ImgGalleryPanel;
